import React from 'react';
import Reveal from '../components/Reveal';

const PARTS = [
  {
    sn: '01',
    name: 'RiscPass',
    kind: 'Passport-anchored identity registry',
    summary:
      'In-house ZK identity solution that exposes a registry of proofs derived from government issued identity documents.',
    tags: ['sp1', 'stark', 'ed25519', 'icao-9303'],
    year: '2025',
    status: 'operated',
    href: 'https://riscpass.com',
    cta: 'riscpass.com',
  },
  {
    sn: '02',
    name: 'Toyni',
    kind: 'STARK proof toolkit',
    summary: 'DEEP-FRI STARK Library written in Rust.',
    tags: ['stark', 'fri', 'babybear', 'cuda'],
    year: '2025',
    status: 'research',
    href: 'https://github.com/jonas089/toyni',
    cta: 'github.com/jonas089/toyni',
  },
  {
    sn: '03',
    name: 'NTT CUDA Kernel',
    kind: 'GPU proving primitive',
    summary: 'CUDA accelerated NTT over Babybear.',
    tags: ['cuda', 'ntt', 'babybear'],
    year: '2025',
    status: 'research',
    href: 'https://github.com/jonas089/zoda-cu/blob/master/cuda/ntt_kernel.cu',
    cta: 'github.com/jonas089/zoda-cu',
  },
  {
    sn: '04',
    name: 'DISEQ',
    kind: 'Distributed sequencer',
    summary: 'Distibuted sequencer prototype with random number consensus.',
    tags: ['consensus', 'bft', 'merkle-patricia'],
    year: '2024',
    status: 'research',
    href: 'https://github.com/jonas089/DISEQ',
    cta: 'github.com/jonas089/DISEQ',
  },
];

const Entry = ({ p }) => {
  const external = p.href !== '#';
  const Tag = external ? 'a' : 'div';

  return (
    <Tag
      className="research-row"
      href={external ? p.href : undefined}
      target={external ? '_blank' : undefined}
      rel={external ? 'noopener noreferrer' : undefined}
    >
      <div>
        <h2
          className="font-display research-name"
          style={{
            fontSize: 'clamp(21px, 1.9vw, 27px)',
            fontWeight: 600,
            letterSpacing: '-0.03em',
            margin: 0,
            lineHeight: 1.15,
          }}
        >
          {p.name}
        </h2>
        <span className="research-link">
          {p.cta} {external && <span className="arrow">→</span>}
        </span>
      </div>

      <p className="prose research-summary">{p.summary}</p>
    </Tag>
  );
};

const Projects = () => (
  <div>
    <section style={{ paddingTop: 'clamp(48px, 7vh, 96px)', paddingBottom: 'clamp(24px, 4vh, 48px)', position: 'relative', overflow: 'hidden' }}>
      <div className="hero-blur" style={{ right: '-220px', top: '-80px', opacity: 0.7 }} />
      <div className="page" style={{ position: 'relative' }}>
        <Reveal delay={0.05}>
          <h1
            className="font-display"
            style={{
              fontSize: 'clamp(44px, min(8vw, 11vh), 128px)',
              fontWeight: 600,
              fontFamily: "'Geist', system-ui, sans-serif",
              letterSpacing: '-0.045em',
              margin: 0,
              color: 'var(--ink)',
              maxWidth: '14ch',
              lineHeight: 0.96,
            }}
          >
            Open research.
          </h1>
        </Reveal>
      </div>
    </section>

    <section style={{ paddingBottom: 'clamp(56px, 8vh, 96px)' }}>
      <div className="page">
        <div className="research-list">
          {PARTS.map((p, i) => (
            <Reveal key={p.sn} delay={i * 0.06}>
              <Entry p={p} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default Projects;
